import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getMunicipality, removeMunicipality } from '../../store/actions/municipalityActions';

import Carousel from '../Global/Carousel';
import Triangles from '../Global/Triangles';
import Accordion from '../Global/Accordion';
import { createImageUrl, getEntityName } from '../../helpers/commonHelpers';
import ImageBlogCard from '../BlogPage/ImageBlogCard';
import loader from '../../assets/animations/loader-b.svg';
import placeholder from '../../assets/images/opcinaLogoCircle.svg';

import { Helmet } from 'react-helmet';

class MunicipalityPage extends Component {

    componentDidMount(){
        const municipalityId = this.props.history.location.pathname.replace('/municipalities/', '');

        if(municipalityId){
            this.props.getMunicipality(municipalityId);
        }
    }
    componentWillUnmount(){
        this.props.removeMunicipality();
    }
    render(){
        const { municipality, region, fetchingMunicipality } = this.props;

        return (
            <div className="breed-page">

                {fetchingMunicipality ? <img src={loader} alt="loader" className="blog-page__loading" /> : <React.Fragment>
                    <Helmet>

                        <title>
                            {region === 'FB' ? 'Općina' : 'Opština'}.ba | {municipality?.name ?? '/'}
                        </title>
                        <meta name="og:image" content={municipality?.main_image ? createImageUrl(municipality?.main_image) : placeholder} />
                        <meta name="og:description" content={municipality?.history} />
                        <meta name="og:title" content={municipality?.name} />
                    </Helmet>
                    <div className="breed-page__top">
                        <Triangles />
                        <div className="breed-page__carousel">
                            <Carousel imageCount={municipality?.images?.length} images={municipality.images} />
                        </div>
                        <div className="breed-page__content">
                            <h1 className="breed-page__title yellow-dark-text">
                                {municipality.name}
                            </h1>
                            <h2 className="breed-page__entity">
                                {getEntityName(municipality.entity)} {municipality.cantonName ? `- ${municipality.cantonName}` : null}
                            </h2>
                            <h2 className="breed-page__facts bold">
                                Ključni brojevi
                        </h2>
                            {/* <p className="breed-page__stats">
                            <span className="breed-page__stat bold">Size:</span> {municipality.size}m
                        </p> */}
                            <p className="breed-page__stats">
                                <span className="breed-page__stat bold">Površina:</span> {municipality.surface} km²
                        </p>
                            <p className="breed-page__stats">
                                <span className="breed-page__stat bold">Broj naselja:</span> {municipality?.settlements ?? 0}
                            </p>
                            <p className="breed-page__stats">
                                <span className="breed-page__stat bold">Populacija:</span> {municipality?.population ?? 0}
                            </p>
                            <p className="breed-page__stats">
                                <span className="breed-page__stat bold">Web stranica: &nbsp;</span>
                                <a href={`${municipality.website ?? ''}`} rel="noopener noreferrer" target="_blank">
                                    {municipality.website ? municipality.website : 'Nije unesena'}
                                </a>
                            </p>
                            <p className="breed-page__stats">
                                <span className="breed-page__stat bold">Poštanski broj:</span> {municipality.zipcode ? municipality.zipcode : '??'}
                            </p>

                            {municipality?.posts?.length ?
                                <React.Fragment>
                                    <h2 className="breed-page__facts bold">
                                        Povezani članci:
                                    </h2>
                                    <div className="breed-page__ratings">
                                        {municipality.posts.map(post => {
                                            return post.isPublished ? <ImageBlogCard post={post} key={post._id} /> : null;
                                        })}
                                    </div>
                                </React.Fragment>
                                : null}

                        </div>

                    </div>
                    <div className="breed-page__bottom">
                        <div className="breed-page__bottom__content">
                            <div className="breed-page__bottom__history">
                                <div className="breed-page__bottom__history__left">
                                    {region ?
                                        <h1 className="breed-page__bottom__history__title">
                                            O {region === 'FB' ? 'općini' : 'opštini'} i njenoj historiji
                                    </h1>
                                        : null}
                                    <p className="breed-page__bottom__history__description">
                                        {municipality.history}
                                    </p>
                                </div>
                                {municipality.main_image ? <img src={createImageUrl(municipality.main_image)} alt="municipality" className="breed-page__bottom__history__dog" /> : null}
                            </div>
                            {municipality?.geography ?
                                <Accordion arrowWhite={true} isExpandable={true} title={'Geografija'} classes="breed-page__accordion">
                                    <React.Fragment>
                                        <p className="breed-page__bottom__text">
                                            {municipality.geography}
                                        </p>
                                    </React.Fragment>
                                </Accordion>
                                : null}
                            {municipality?.people ?
                                <Accordion arrowWhite={true} isExpandable={true} title={'Stanovništvo'} classes="breed-page__accordion">
                                    <React.Fragment>
                                        <p className="breed-page__bottom__text">
                                            {municipality.people}
                                        </p>
                                    </React.Fragment>
                                </Accordion>
                                : null}
                            {municipality?.industry ?
                                <Accordion arrowWhite={true} isExpandable={true} title={'Privreda'} classes="breed-page__accordion">
                                    <React.Fragment>
                                        <p className="breed-page__bottom__text">
                                            {municipality.industry}
                                        </p>
                                    </React.Fragment>
                                </Accordion>
                                : null}
                            {municipality?.culture ?
                                <Accordion arrowWhite={true} isExpandable={true} title={'Kultura'} classes="breed-page__accordion">
                                    <React.Fragment>
                                        <p className="breed-page__bottom__text">
                                            {municipality.culture}
                                        </p>
                                    </React.Fragment>
                                </Accordion>
                                : null}
                            {municipality?.sport ?
                                <Accordion arrowWhite={true} isExpandable={true} title={'Sport'} classes="breed-page__accordion">
                                    <React.Fragment>
                                        <p className="breed-page__bottom__text">
                                            {municipality.sport}
                                        </p>
                                    </React.Fragment>
                                </Accordion>
                                : null}

                        </div>
                    </div>
                    </React.Fragment>}
            </div>
        );
    }
}

const setStateToProps = (state) => {
    return {
        municipality: state.municipalities.municipality,
        region: state.common.region,
        fetchingMunicipality: state.municipalities.fetchingMunicipality
    }
}

const setDispatchToProps = (dispatch) => {
    return {
        getMunicipality: (id) => { dispatch(getMunicipality(id)) },
        removeMunicipality: () => { dispatch(removeMunicipality()) }
    }
}

export default connect(setStateToProps, setDispatchToProps)(withRouter(MunicipalityPage));